// Reuse the history detail receipt styling so the payment receipt matches Transaction History.
import { useTranslation } from "react-i18next";
import styles from "../../history/customer-history-detail/customer-transaction-history-detail.module.scss";
import { formatDate, formatTime } from "../../history/history.utils";
import { formatCurrency, handleCopy } from "../../../../utils";
import { CopyIcon } from "../../../../assets/icons";
import { PrepaidTransactionData, StatementOfAccountTransaction } from "../../../../model/vending/vending-interfaces";

interface PaymentReceiptBodyProps {
	detail: PrepaidTransactionData;
	transaction?: StatementOfAccountTransaction;
	shareView: boolean;
}

// Empty/missing values render as "/".
const EMPTY = "/";
const show = (value: string | number | null | undefined): string => (value === null || value === undefined || value === "" ? EMPTY : String(value));

export const PaymentReceiptBody = ({ detail, transaction, shareView }: PaymentReceiptBodyProps) => {
	const { t } = useTranslation();
	const showDate = (value: string | null): string => (value ? `${formatDate(value)}, ${formatTime(value).toLocaleLowerCase()}` : EMPTY);
	const currency = transaction?.amount?.currency;
	const referenceId = transaction?.referenceId ?? detail.receiptNumber;

	// Every field returned by the prepaid transaction detail endpoint.
	const rows: { label: string; value: string }[] = [
		{ label: t("common.labels.customerName"), value: show(detail.customerName) },
		{ label: t("common.labels.address"), value: show(detail.customerAddress) },
		{ label: t("common.labels.meterNumber"), value: show(detail.meterNumber) },
		{ label: t("history.web.electricitySerialNumber"), value: show(detail.electricitySerialNumber) },
		{ label: t("history.tokenLabel"), value: show(detail.token) },
		{ label: t("history.web.unitPurchased"), value: detail.totalKwh != null ? `${detail.totalKwh} kWh` : EMPTY },
		{ label: t("history.tariff"), value: show(detail.tariffName) },
		// { label: t("history.web.tariffIndex"), value: show(detail.tariffIndex) },
		{ label: t("common.labels.amount"), value: detail.transactionAmount != null ? formatCurrency(detail.transactionAmount, { currency }) : EMPTY },
		// { label: t("history.web.vendType"), value: show(detail.vendType) },
		{ label: t("history.web.operatorName"), value: show(detail.operatorName) },
		{ label: t("history.web.paymentPartner"), value: show(detail.vendorCompanyName) },
		{ label: t("history.web.stationCode"), value: show(detail.stationCode) },
		{ label: t("history.web.supplyGroupCode"), value: show(detail.supplyGroupCode) },
		{ label: t("history.web.receiptNumber"), value: show(detail.receiptNumber) },
		{ label: t("common.labels.date"), value: showDate(detail.createdDateTime) },
		{ label: t("history.web.completedDate"), value: showDate(detail.completedDateTime) },
	];

	return (
		<>
			<div className={styles.detailsCard}>
				{rows.map(row => (
					<div className={styles.detailRow} key={row.label}>
						<span className={styles.receiptLabel}>{row.label}</span>
						<span className={styles.receiptValue}>{row.value}</span>
					</div>
				))}
			</div>

			{shareView && (
				<div className={styles.footer}>
					<div className={styles.detailRow}>
						<span className={styles.receiptLabel}>{t("history.transactionIdLabel")}</span>
						<div className={styles.copyContainer}>
							<span className={styles.receiptValue}>{referenceId || EMPTY}</span>
							{referenceId && <CopyIcon onClick={() => handleCopy(referenceId)} className={styles.copyBtn} />}
						</div>
					</div>
				</div>
			)}
		</>
	);
};
